// Keep the exclusions aligned with ApplicationHelper#tracker_sensitive_page?.
// A destination's reload meta tag is too late: Turbolinks calls pushState before
// rendering its response, and an already loaded Insight Tag observes that call.
function sensitiveUrl(value) {
  const url = new URL(value, window.location.href);
  let pathname;
  try {
    pathname = decodeURIComponent(url.pathname);
  } catch (_) {
    return true; // Let the server handle malformed paths through a full load.
  }
  return /^\/(?:auth|teachable_users|cuenta\/ajustes|acceder|registro)(?:\/|$)/.test(pathname) ||
    Array.from(url.searchParams.keys()).some(key => /(?:^|_)token$/i.test(key));
}

document.addEventListener('turbolinks:before-visit', event => {
  if (sensitiveUrl(window.location.href) || sensitiveUrl(event.data.url)) {
    event.preventDefault();
    window.location.assign(event.data.url);
  }
});
